module.exports = __webpack_public_path__ + "media/images/trait-ffd26ab2dab0cdfd7eefdc01f5310c3b.png";